import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-return',
  templateUrl: './return.component.html',
  styleUrls: ['./return.component.scss']
})
export class ReturnComponent implements OnInit, OnChanges {

  constructor(
    private location: Location
  ) { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {}

  goBack(): void {
    this.location.back();
  }

}
